import React from "react";
import { X } from "react-feather";
import FeatherIcon from "feather-icons-react";
const IndependentSKULayout = React.forwardRef(
  ({ 
    isVisible, 
    isFullScreen, 
    setIsFullScreen, 
    onClose, 
    resetState, 
    skuId, 
    offerSKU, 
    headerState,
    children,
    title
  }, ref) => {

    return (
      <div
        ref={ref}
        className={`right-sidebar ${isVisible ? "visible" : ""}`}
        style={{
          position: "fixed",
          top: headerState ? 0 : 66,
          right: 0,
          height: "100%",
          zIndex: 1050,
          width: isFullScreen ? "60%" : "555px",
          backgroundColor: "#fff",
          boxShadow: "0 0 3px rgba(0, 0, 0, 0.6)",
          overflowY: "auto",
          overflowX: "hidden",
          transition: "transform 0.3s ease-in-out",
          transform: isVisible ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <div
          className="sidebar-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h5>
            {title || (
              skuId ? (
                <>
                  Marketing SKU <u>{offerSKU.skuCode}</u>
                </>
              ) : (
                "Create New Marketing SKU"
              )
            )}
          </h5>
          <div>
            <button
              onClick={() => setIsFullScreen(!isFullScreen)}
              className="btn"
            >
              <FeatherIcon icon={isFullScreen ? "minimize" : "maximize"} />
            </button>
            <button
              className="btn"
              onClick={() => {
                onClose();
                resetState && resetState();
              }}
            >
              <X />
            </button>
          </div>
        </div>
        <div className="p-3">
          {children}
        </div>
        <div style={{ height: 100 }}></div>
      </div>
    );
  }
);

IndependentSKULayout.displayName = "IndependentSKULayout";
export default IndependentSKULayout;
